import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-14 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-home-heart-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50 whitespace-nowrap">
                心灵家缘
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              专注家庭情感关系研究，帮助每个家庭成员找到恰当的角色定位，构建和谐美满的家庭关系。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-categories" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-links" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
              </li>
              <li>
                <Link to="/category/xiangchu-zhidao" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">小姨子相处之道</Link>
              </li>
              <li>
                <Link to="/category/qinggan-bianjie" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">家庭情感边界</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-contact" className="hover:text-primary-400 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-primary-400"></i>
                </div>
                <span className="whitespace-nowrap">contact@xinlingjiayuan.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-primary-400"></i>
                </div>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 心灵家缘. 保留所有权利.
          </p>
          <div className="flex items-center gap-5">
            <a
              href="https://weibo.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-background-500 hover:text-primary-400 transition-colors"
              aria-label="微博"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-weibo-line"></i>
              </div>
            </a>
            <a
              href="https://weixin.qq.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-background-500 hover:text-primary-400 transition-colors"
              aria-label="微信"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-wechat-line"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}